import { filter, fromPairs, isEmpty, map } from 'lodash';

import { getWidgetSessionProviderByIdAndCourseId } from 'bundles/author-common/utils/AuthoringWidgetSessionAPIUtils';
import type {
  AuthoringWidgetSummariesV1,
  GradingType,
} from 'bundles/naptimejs/resources/__generated__/AuthoringWidgetSummariesV1';
import { getAuthoringWidgetSummary } from 'bundles/widget-admin/utils/WidgetAdminAPIUtils';

export const isAssetSelected = (selectedWidgets: $TSFixMe, widget: $TSFixMe) => {
  return !isEmpty(filter(selectedWidgets, { id: widget.id }));
};

export const createWidgetMap = (widgets: $TSFixMe) => {
  return fromPairs(map(widgets, (widget: any) => [widget.id, widget]));
};

// a widget session provider is a "usage spot" for a widget. it's where a widget is used in a course
export const getWidgetQuestionProvider = ({
  widgetQuestionProviderId,
  questionId,
  courseId,
}: {
  widgetQuestionProviderId: string;
  questionId: string;
  courseId: string;
}) => {
  return getWidgetSessionProviderByIdAndCourseId({
    id: widgetQuestionProviderId,
    courseId,
  }).then((response) => {
    const widgetProvider = response.elements[0];
    const widgetSessionProviderId = widgetProvider.id;
    const widgetDraft = widgetProvider.draft;
    const widgetDraftSummary = response.linked['authoringWidgetSummaries.v1'][0];
    const { isPublished, metadata, owners } = widgetProvider;
    return {
      widgetDraft,
      widgetDraftSummary,
      widgetSessionProviderId,
      questionId,
      isPublished,
      metadata,
      owners,
    };
  });
};

// an authoring widget summary is an aggregate of information about a widget, combining info from a few sources like the authoringWidget, instances (ie where that widget is used), and permissioning (viewScope) which determines if it's soft deleted.
export const getAuthoringWidgetSummaryListByCourse = (
  courseId: string,
  gradingTypes: GradingType[],
  filterPublished: boolean,
  filterHidden: boolean
) => {
  const matchesHiddenFilter = ({ isHidden }: AuthoringWidgetSummariesV1) => (filterHidden ? !isHidden : true);
  const matchesGradingType = ({ gradingType: gradingTypeFromWidget, pluginType }: AuthoringWidgetSummariesV1) => {
    // For UNGRADED type: return any UNGRADED plugin OR any SCORM plugin (regardless of SCORM's grading status)
    if (gradingTypes.includes('UNGRADED')) {
      return gradingTypeFromWidget === 'UNGRADED' || pluginType === 'SCORM';
    }

    return gradingTypeFromWidget && gradingTypes.includes(gradingTypeFromWidget);
  };

  const matchesPublishedFilter = ({ isPublished }: AuthoringWidgetSummariesV1) =>
    filterPublished ? !isPublished : true;

  return getAuthoringWidgetSummary(courseId).then((response) => {
    const widgetList = filter(response.elements, (widget) => {
      return matchesHiddenFilter(widget) && matchesGradingType(widget) && matchesPublishedFilter(widget);
    });

    return widgetList;
  });
};
